import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./dateRangePicker.scss"; // Custom styles
import styles from "./dateRangePicker.module.scss";

const DateRangePicker = ({
  monthsShown,
  onChange,
  minDate,
  maxDate,
  defaultDate,
  label,
  size,
  required,
  disabled,
  error,
  
}) => {


  const ref = React.useRef(null);
  const [show, setShow] = useState(false);

  const [dates, setDates] = useState({
    start: null,
    end: null,
  });

  useEffect(() => {
    if (
      defaultDate?.startDate &&
      defaultDate?.endDate &&
      !dates?.start &&
      !dates?.end
    ) {
      setDates({
        start: defaultDate?.startDate ? new Date(defaultDate?.startDate) : null,
        end: defaultDate?.endDate ? new Date(defaultDate?.endDate) : null,
      });
    }
  }, [defaultDate]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setShow(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const getDateByMonth = (dateStr) => {
    const date = new Date(dateStr);

    // Get day, month, and year in the required format
    const day = date.toLocaleDateString("en-GB", { day: "2-digit" });
    const month = date.toLocaleDateString("en-GB", { month: "short" });
    const year = date
      .toLocaleDateString("en-GB", { year: "numeric" })
      .toUpperCase();

    return `${day} ${month}, ${year}`;
  };

  const formatDate = (date) => {
    return date ? date.toLocaleDateString("en-CA") : null; // 'en-CA' outputs in YYYY-MM-DD format
  };

  return (
    <div
      className={`${styles.custom_date_range_picker_new_design_system_container} `}
    >
      {label ? (
        <div
          className={`${styles.label}  ${
            size === "small"
              ? styles.small
              : size === "medium"
              ? styles.medium
              : styles.large
          } `}
        >
          {label}{" "}
          {required === true ? <span style={{ color: "red" }}> *</span> : ""}
        </div>
      ) : null}

      <div
        className={`${styles.date_picker_container} ${
          size === "small"
            ? styles.small
            : size === "medium"
            ? styles.medium
            : (size = "large" ? styles.large : "null")
        }    ${error ? styles.error : "null"}`}
        onClick={() => !disabled && setShow(!show)}
        style={
          show
            ? { border: "1px solid #3968ed" }
            : { }
        }
        ref={ref}
      >
        <svg
          width="12"
          height="15"
          viewBox="0 0 12 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.33333 14.1667C0.966667 14.1667 0.652778 14.0361 0.391667 13.775C0.130556 13.5139 0 13.2 0 12.8333V3.5C0 3.13333 0.130556 2.81944 0.391667 2.55833C0.652778 2.29722 0.966667 2.16667 1.33333 2.16667H2V1.5C2 1.31111 2.06389 1.15278 2.19167 1.025C2.31944 0.897221 2.47778 0.833332 2.66667 0.833332C2.85556 0.833332 3.01389 0.897221 3.14167 1.025C3.26944 1.15278 3.33333 1.31111 3.33333 1.5V2.16667H8.66667V1.5C8.66667 1.31111 8.73056 1.15278 8.85833 1.025C8.98611 0.897221 9.14444 0.833332 9.33333 0.833332C9.52222 0.833332 9.68056 0.897221 9.80833 1.025C9.93611 1.15278 10 1.31111 10 1.5V2.16667H10.6667C11.0333 2.16667 11.3472 2.29722 11.6083 2.55833C11.8694 2.81944 12 3.13333 12 3.5V12.8333C12 13.2 11.8694 13.5139 11.6083 13.775C11.3472 14.0361 11.0333 14.1667 10.6667 14.1667H1.33333ZM1.33333 12.8333H10.6667V6.16667H1.33333V12.8333ZM1.33333 4.83333H10.6667V3.5H1.33333V4.83333ZM6 8.83333C5.81111 8.83333 5.65278 8.76944 5.525 8.64167C5.39722 8.51389 5.33333 8.35555 5.33333 8.16667C5.33333 7.97778 5.39722 7.81944 5.525 7.69167C5.65278 7.56389 5.81111 7.5 6 7.5C6.18889 7.5 6.34722 7.56389 6.475 7.69167C6.60278 7.81944 6.66667 7.97778 6.66667 8.16667C6.66667 8.35555 6.60278 8.51389 6.475 8.64167C6.34722 8.76944 6.18889 8.83333 6 8.83333ZM3.33333 8.83333C3.14444 8.83333 2.98611 8.76944 2.85833 8.64167C2.73056 8.51389 2.66667 8.35555 2.66667 8.16667C2.66667 7.97778 2.73056 7.81944 2.85833 7.69167C2.98611 7.56389 3.14444 7.5 3.33333 7.5C3.52222 7.5 3.68056 7.56389 3.80833 7.69167C3.93611 7.81944 4 7.97778 4 8.16667C4 8.35555 3.93611 8.51389 3.80833 8.64167C3.68056 8.76944 3.52222 8.83333 3.33333 8.83333ZM8.66667 8.83333C8.47778 8.83333 8.31944 8.76944 8.19167 8.64167C8.06389 8.51389 8 8.35555 8 8.16667C8 7.97778 8.06389 7.81944 8.19167 7.69167C8.31944 7.56389 8.47778 7.5 8.66667 7.5C8.85556 7.5 9.01389 7.56389 9.14167 7.69167C9.26945 7.81944 9.33333 7.97778 9.33333 8.16667C9.33333 8.35555 9.26945 8.51389 9.14167 8.64167C9.01389 8.76944 8.85556 8.83333 8.66667 8.83333ZM6 11.5C5.81111 11.5 5.65278 11.4361 5.525 11.3083C5.39722 11.1806 5.33333 11.0222 5.33333 10.8333C5.33333 10.6444 5.39722 10.4861 5.525 10.3583C5.65278 10.2306 5.81111 10.1667 6 10.1667C6.18889 10.1667 6.34722 10.2306 6.475 10.3583C6.60278 10.4861 6.66667 10.6444 6.66667 10.8333C6.66667 11.0222 6.60278 11.1806 6.475 11.3083C6.34722 11.4361 6.18889 11.5 6 11.5ZM3.33333 11.5C3.14444 11.5 2.98611 11.4361 2.85833 11.3083C2.73056 11.1806 2.66667 11.0222 2.66667 10.8333C2.66667 10.6444 2.73056 10.4861 2.85833 10.3583C2.98611 10.2306 3.14444 10.1667 3.33333 10.1667C3.52222 10.1667 3.68056 10.2306 3.80833 10.3583C3.93611 10.4861 4 10.6444 4 10.8333C4 11.0222 3.93611 11.1806 3.80833 11.3083C3.68056 11.4361 3.52222 11.5 3.33333 11.5ZM8.66667 11.5C8.47778 11.5 8.31944 11.4361 8.19167 11.3083C8.06389 11.1806 8 11.0222 8 10.8333C8 10.6444 8.06389 10.4861 8.19167 10.3583C8.31944 10.2306 8.47778 10.1667 8.66667 10.1667C8.85556 10.1667 9.01389 10.2306 9.14167 10.3583C9.26945 10.4861 9.33333 10.6444 9.33333 10.8333C9.33333 11.0222 9.26945 11.1806 9.14167 11.3083C9.01389 11.4361 8.85556 11.5 8.66667 11.5Z"
            fill="#858585"
          />
        </svg>
        <span>
          {dates.start && dates.end ? (
            getDateByMonth(dates.start) + " - " + getDateByMonth(dates.end)
          ) : dates.start && !dates.end ? (
            getDateByMonth(dates.start) + " - " // Only show start date with a trailing dash
          ) : (
            <span style={{ color: "#858585" }}>Select Date</span>
          )}
        </span>

        {show && (
          <div
            onClick={(e) => e.stopPropagation()}
            style={{ zIndex: "2000000" }}
            className={`custom_date_range_picker_new_design_system ${styles.custom_date_range_picker_new_design_system}`}
          >
            <DatePicker
              disabled = {true}
              onChange={(dateRange) => {
                const [start, end] = dateRange || [];

                // Ensure start and end are valid Date objects
                if (
                  start instanceof Date &&
                  !isNaN(start.getTime()) &&
                  end instanceof Date &&
                  !isNaN(end.getTime())
                ) {
                  setDates({ start, end }); // Set both start and end dates
                  if (onChange) {
                    onChange(formatDate(start), formatDate(end)); // Pass formatted dates to parent handler
                  }
                  setShow(false); // Close the calendar after selecting the range
                } else if (start instanceof Date && !isNaN(start.getTime())) {
                  setDates({ start, end: null }); // Keep end null if only start is selected
                }
              }}
              startDate={dates.start}
              endDate={dates.end}
              selectsRange
              inline
              monthsShown={monthsShown || 1}
              minDate={minDate && new Date(minDate)}
              maxDate={maxDate && new Date(maxDate)}
              dayClassName={(date) => {
                if (date.getTime() === dates.start?.getTime()) {
                  return "start-range";
                }
                if (date.getTime() === dates.end?.getTime()) {
                  return "end-range";
                }
                if (dates.start && date > dates.start && date < dates.end) {
                  return "in-range";
                }
                return "";
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DateRangePicker;
